import { Text } from "@clipboard-health/ui-components";
import { CircularProgress, Stack } from "@mui/material";

export function NewsFeedLoadingPageState() {
  return (
    <Stack spacing={4} flexGrow={1} justifyContent="center" alignItems="center">
      <CircularProgress />
      <Text>Loading news feed...</Text>
    </Stack>
  );
}
